import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var GitCommit = createReactComponent("GitCommit", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "3",
  key: "n6u7h6"
}], ["line", {
  x1: "3",
  y1: "12",
  x2: "9",
  y2: "12",
  key: "akdq56"
}], ["line", {
  x1: "15",
  y1: "12",
  x2: "21",
  y2: "12",
  key: "gr5rsn"
}]]]);
export default GitCommit;